import { BaseService } from '@core/base.service';
import { Observable } from 'rxjs';
import {
    ChangeTenantStatusInterface,
    TenantsInterface,
} from '@shared/interfaces/tenants.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class TenantsService {
    constructor(private baseService: BaseService) {}

    getAllTenants(): Observable<TenantsInterface[]> {
        return this.baseService.get('tenants');
    }

    archiveTenants(tenantIds: number[]): Observable<void> {
        const payload: ChangeTenantStatusInterface = { tenantIds };
        return this.baseService.create('tenants/archive', payload);
    }
}
